import { useState } from '~coreModules/core/js/composables/vuexHelpers';

import useAnalyticsPageView from '~coreModules/analytics/js/composables/use-analytics-pageview';

import { DISCOVER_MODULE_NAME } from '~coreModules/discover/js/discover-store';

import { BROWSE_MODULE_NAME } from '~routes/browse/js/browse-store';

export default function useBrowseAnalytics() {
    const { pagination } = useState(BROWSE_MODULE_NAME, {
        pagination: state => state.catalog.pagination,
    });

    const { ancestorSlugs } = useState(DISCOVER_MODULE_NAME, {
        ancestorSlugs: state => state.navItem?.ancestorSlugs || [],
    });

    function getAnalyticsData() {
        return {
            currentPage: {
                meta: {
                    analytics: {
                        pageCategory: 'browse',
                        pageType: 'browse',
                    },
                },
            },
            pageData: {
                catalog: {
                    pageNumber: pagination.value.pageNumber,
                    totalPageCount: pagination.value.totalPages,
                    categoryLevel: ancestorSlugs.value.length,
                    categoryRoot: ancestorSlugs.value?.[0],
                    categoryLevelTwo: ancestorSlugs?.value?.[1] || null,
                    categoryLevelThree: ancestorSlugs?.value?.[2] || null,
                },
            },
        };
    }

    useAnalyticsPageView({ getAnalyticsData });
}
